// Field schemas drive the generic entity editors. Types: i18n | text | image | bool
export const ENTITY_SCHEMAS = {
  events: {
    label: 'Eventi',
    pageKey: 'events',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Titolo' },
      { key: 'badge', type: 'i18n', label: 'Categoria (badge)' },
      { key: 'cat', type: 'text', label: 'Categoria (id filtro)' },
      { key: 'date', type: 'text', label: 'Data' },
      { key: 'time', type: 'text', label: 'Ora' },
      { key: 'place', type: 'i18n', label: 'Luogo' },
      { key: 'text', type: 'i18n', label: 'Descrizione', multiline: true },
      { key: 'image', type: 'image', label: 'Immagine' },
    ],
  },
  places: {
    label: 'Vicino a te',
    pageKey: 'nearby',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Titolo' },
      { key: 'featured', type: 'bool', label: 'In evidenza (card grande)' },
      { key: 'badge', type: 'i18n', label: 'Categoria (badge)' },
      { key: 'cat', type: 'text', label: 'Categoria (id filtro)' },
      { key: 'sub', type: 'i18n', label: 'Sottotitolo (lista)' },
      { key: 'distance', type: 'text', label: 'Distanza' },
      { key: 'text', type: 'i18n', label: 'Descrizione', multiline: true },
      { key: 'image', type: 'image', label: 'Immagine' },
    ],
  },
  museums: {
    label: 'Arte & Musei',
    pageKey: 'art_museums',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Titolo' },
      { key: 'featured', type: 'bool', label: 'In evidenza (card grande)' },
      { key: 'tag', type: 'i18n', label: 'Tag' },
      { key: 'address', type: 'text', label: 'Indirizzo' },
      { key: 'sub', type: 'i18n', label: 'Sottotitolo (lista)' },
      { key: 'distance', type: 'text', label: 'Distanza' },
      { key: 'image', type: 'image', label: 'Immagine' },
    ],
  },
  services: {
    label: 'Servizi & Convenzioni',
    pageKey: 'services',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Titolo' },
      { key: 'badge', type: 'i18n', label: 'Categoria (badge)' },
      { key: 'cat', type: 'text', label: 'Categoria (id filtro)' },
      { key: 'discount', type: 'i18n', label: 'Sconto / offerta' },
      { key: 'text', type: 'i18n', label: 'Descrizione', multiline: true },
      { key: 'meta1', type: 'i18n', label: 'Info 1 (distanza)' },
      { key: 'meta2', type: 'i18n', label: 'Info 2 (orario)' },
      { key: 'image', type: 'image', label: 'Immagine' },
    ],
  },
  experiences: {
    label: 'Esperienze',
    pageKey: 'experiences',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Titolo' },
      { key: 'badge', type: 'i18n', label: 'Categoria (badge)' },
      { key: 'cat', type: 'text', label: 'Categoria (id filtro)' },
      { key: 'place', type: 'i18n', label: 'Luogo' },
      { key: 'text', type: 'i18n', label: 'Descrizione', multiline: true },
      { key: 'duration', type: 'text', label: 'Durata' },
      { key: 'people', type: 'text', label: 'Persone' },
      { key: 'price', type: 'text', label: 'Prezzo' },
      { key: 'image', type: 'image', label: 'Immagine' },
    ],
  },
  banners: {
    label: 'Banner Homepage',
    pageKey: 'guest_home',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Titolo' },
      { key: 'text', type: 'i18n', label: 'Descrizione', multiline: true },
      { key: 'badge', type: 'i18n', label: 'Etichetta' },
      { key: 'image', type: 'image', label: 'Immagine' },
      { key: 'button', type: 'i18n', label: 'Testo pulsante' },
      { key: 'link', type: 'text', label: 'Link (URL/percorso)' },
      { key: 'start', type: 'text', label: 'Data inizio (YYYY-MM-DD)' },
      { key: 'end', type: 'text', label: 'Data fine (YYYY-MM-DD)' },
    ],
  },
  partners: {
    label: 'Partner',
    pageKey: 'services',
    titleField: 'title',
    fields: [
      { key: 'title', type: 'i18n', label: 'Nome partner' },
      { key: 'category', type: 'text', label: 'Categoria' },
      { key: 'badge', type: 'i18n', label: 'Etichetta' },
      { key: 'discount', type: 'i18n', label: 'Sconto / convenzione' },
      { key: 'text', type: 'i18n', label: 'Descrizione', multiline: true },
      { key: 'address', type: 'text', label: 'Indirizzo' },
      { key: 'website', type: 'text', label: 'Sito web' },
      { key: 'meta1', type: 'i18n', label: 'Info 1' },
      { key: 'meta2', type: 'i18n', label: 'Info 2' },
      { key: 'image', type: 'image', label: 'Logo / Immagine' },
    ],
  },
};

export const PAGE_ONLY = {
  guest_home: { label: 'Home ospite', scope: 'tenant' },
  info_bnb: { label: 'Info BnB', scope: 'tenant' },
  domira_home: { label: 'Landing Domira', scope: 'global' },
};
